import { SUCCESS, REQUEST, ERROR } from './types'
import { apiDate } from '../../utils/dateHelper'

const state = {
  data: {},
  loading: false,
  error: false,
}

const getters = {
  ocr: (state) => state.data,
  loading: (state) => state.loading,
  error: (state) => state.error,
}

const actions = {
  async setOcr(context, payload) {
    try {
      context.commit(REQUEST)

      const response = await context.dispatch(
        `api`,
        {
          entity: `ocr`,
          action: `post`,
          payload,
        },
        { root: true }
      )

      if (response.status !== 200) throw response

      const { data } = response

      const structuredData = {
        ...data,
        identity: data.identity_rg,
        identityAgency: data.identity_agency,
        identityUf: data.identity_uf,
        birth: apiDate(data.birthday),
        password: data.cpf,
        firstLicense: apiDate(data.first_habilitation),
        issuance: apiDate(data.issuance_date),
        fullName: data.name,
        validate: apiDate(data.validate_date),
        security: data.securityNumber,
        cnhUf: data.uf,
        location: data.place
      }

      context.commit(SUCCESS, structuredData)
    } catch (err) {
      console.error(err)
      context.commit(ERROR)
    }
  },
}

const mutations = {
  [REQUEST](state) {
    state.loading = true
  },
  [SUCCESS](state, payload) {
    state.data = payload
    state.loading = false
    state.error = false
  },
  [ERROR](state) {
    state.error = true
    state.loading = false
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
